// extracted by mini-css-extract-plugin
export var connectionButton = "_bm-1";
export var connectionButtonFloating = "_bm-2";
export var connectionContainer = "_bm-0";
export var rightPanel = "_bm-6";
export var stepCard = "_bm-3";
export var stepCardSubtitle = "_bm-5";
export var stepCardText = "_bm-4";